import React from "react";
import {Config} from '../Config';
import * as Utils from '../inc/Utils';
import {NavLink, useSearchParams} from "react-router-dom";
import Pagination from "react-js-pagination";
import IconWeb from '../img/icons/icon-web.svg';
import * as XLSX from "xlsx";
import {saveAs} from "file-saver";

export default function Research(prop) {
    let [searchParams] = useSearchParams();

    let [data, setData] = React.useState(null);
    let [listing, setListing] = React.useState(null);
    let [researchType, setResearchType] = React.useState(null);
    let [researchFormat, setResearchFormat] = React.useState(null);
    let [researchDoctype, setResearchDoctype] = React.useState(null);
    let [researchAgency, setResearchAgency] = React.useState(null);
    let [capitalType, setCapitalType] = React.useState(null);
    let [capitalSource, setCapitalSource] = React.useState(null);
    let [fiscalYear, setFiscalYear] = React.useState(null);
    let [researchTypeId, setResearchTypeId] = React.useState('');
    let [researchFormatId, setResearchFormatId] = React.useState('');
    let [researchDoctypeId, setResearchDoctypeId] = React.useState('');
    let [researchAgencyId, setResearchAgencyId] = React.useState('');
    let [capitalTypeId, setCapitalTypeId] = React.useState('');
    let [capitalSourceId, setCapitalSourceId] = React.useState('');
    let [fiscalYearId, setFiscalYearId] = React.useState('');
    let [researchFromOther, setResearchFromOther] = React.useState(null);

    let [itemPerpage, setItemPerpage] = React.useState(12);
    let [countAllItem, setCountAllItem] = React.useState(0);
    let [activePage, setActivePage] = React.useState(1);
    let [totalPage, setTotalPage] = React.useState(0);

    let refKeyword = React.useRef();

    React.useEffect(() => {
        let title = (prop.lang === 'en' ? 'Research':'ข้อมูลงานวิจัย') + ' | NCSA';
        document.title = title;
        const elDesc = document.querySelector("meta[name='description']");
        elDesc.setAttribute('content', title);
        const elOgTitle = document.querySelector("meta[property='og:title']");
        elOgTitle.setAttribute('content', title);
        const elOgDesc = document.querySelector("meta[property='og:description']");
        elOgDesc.setAttribute('content', title);
        const elOgImage = document.querySelector("meta[property='og:image']");
        elOgImage.setAttribute('content', Config.baseUrl + 'images/default.jpg');
        const elOgUrl = document.querySelector("meta[property='og:url']");
        elOgUrl.setAttribute('content', window.location.href);

        if(searchParams.get('researchTypeId')) {
            setResearchTypeId(searchParams.get('researchTypeId'));
        }
        else {
            setResearchTypeId(null);
        }
        if(searchParams.get('researchFormatId')) {
            setResearchFormatId(searchParams.get('researchFormatId'));
        }
        else {
            setResearchFormatId(null);
        }
        if(searchParams.get('researchDoctypeId')) {
            setResearchDoctypeId(searchParams.get('researchDoctypeId'));
        }
        else {
            setResearchDoctypeId(null);
        }
        if(searchParams.get('researchAgencyId')) {
            setResearchAgencyId(searchParams.get('researchAgencyId'));
        }
        else {
            setResearchAgencyId(null);
        }
        if(searchParams.get('capitalTypeId')) {
            setCapitalTypeId(searchParams.get('capitalTypeId'));
        }
        else {
            setCapitalTypeId(null);
        }
        if(searchParams.get('capitalSourceId')) {
            setCapitalSourceId(searchParams.get('capitalSourceId'));
        }
        else {
            setCapitalSourceId(null);
        }
        if(searchParams.get('fiscalYearId')) {
            setFiscalYearId(searchParams.get('fiscalYearId'));
        }
        else {
            setFiscalYearId(null);
        }

        if(searchParams.get('keyword')) {
            refKeyword.current.value = searchParams.get('keyword');
        }
        else {
            refKeyword.current.value = '';
        }

        (async function() {
            try {
                const resView = await getView();
                setData(resView);

                const resListing = await getListing();
                setListing(resListing);
                if(resListing !== null) {
                    setCountAllItem(resListing.count);
                    setTotalPage(resListing.count > 0 ? (resListing.count / itemPerpage) : 1);
                }

                const resResearchFromOther = await getResearchFromOther();
                setResearchFromOther(resResearchFromOther);

                const resResearchType = await getResearchType();
                setResearchType(resResearchType);

                const resResearchFormat = await getResearchFormat();
                setResearchFormat(resResearchFormat);

                const resResearchDoctype = await getResearchDoctype();
                setResearchDoctype(resResearchDoctype);

                const resResearchAgency = await getResearchAgency();
                setResearchAgency(resResearchAgency);

                const resCapitalType = await getCapitalType();
                setCapitalType(resCapitalType);

                const resCapitalSource = await getCapitalSource();
                setCapitalSource(resCapitalSource);

                const resFiscalYear = await getFiscalYear();
                setFiscalYear(resFiscalYear);
            } catch (e) {
                //
            }
        })();
    }, [searchParams]);

    const onPageChange = async (pageNum) => {
        setActivePage(pageNum);
        const resListing = await getListing(pageNum);
        setListing(resListing);
        if(resListing !== null) {
            setCountAllItem(resListing.count);
            setTotalPage(resListing.count > 0 ? (resListing.count / itemPerpage) : 1);
        }
    };

    const onChangeResearchType = (e) => {
        setResearchTypeId(e.target.value);
    };

    const onChangeResearchFormat = (e) => {
        setResearchFormatId(e.target.value);
    };

    const onChangeResearchDoctype = (e) => {
        setResearchDoctypeId(e.target.value);
    };

    const onChangeResearchAgency = (e) => {
        setResearchAgencyId(e.target.value);
    };

    const onChangeCapitalType = (e) => {
        setCapitalTypeId(e.target.value);
    };

    const onChangeCapitalSource = (e) => {
        setCapitalSourceId(e.target.value);
    };

    const onChangeFiscalYear = (e) => {
        setFiscalYearId(e.target.value);
    };

    const onSearch = (e) => {
        let param = [];
        if(refKeyword.current.value) {
            param.push('keyword=' + refKeyword.current.value);
        }
        if(researchTypeId !== null) {
            param.push('researchTypeId=' + researchTypeId);
        }
        if(researchFormatId !== null) {
            param.push('researchFormatId=' + researchFormatId);
        }
        if(researchDoctypeId !== null) {
            param.push('researchDoctypeId=' + researchDoctypeId);
        }
        if(researchAgencyId !== null) {
            param.push('researchAgencyId=' + researchAgencyId);
        }
        if(capitalTypeId !== null) {
            param.push('capitalTypeId=' + capitalTypeId);
        }
        if(capitalSourceId !== null) {
            param.push('capitalSourceId=' + capitalSourceId);
        }
        if(fiscalYearId !== null) {
            param.push('fiscalYearId=' + fiscalYearId);
        }
        window.location = (prop.lang === 'en' ? '/en': '/') + 'research' + (param.length > 0 ? '?' + param.join('&') : '');
    };

    async function getView() {
        const response = await fetch(Config.apiUrl +'/researchBanner/view', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id: 1
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getListing(pageNum, itemPerpage = 12) {
        if(pageNum !== null) {
            activePage = pageNum;
        }

        let newResearchTypeId = null;
        let newResearchFormatId = null;
        let newResearchDocTypeId = null;
        let newResearchAgencyId = null;
        let newCapitalTypeId = null;
        let newCapitalSourceId = null;
        let newFiscalYearId = null;
        if(searchParams.get('researchTypeId')) {
            newResearchTypeId = searchParams.get('researchTypeId');
        }
        if(searchParams.get('researchFormatId')) {
            newResearchFormatId = searchParams.get('researchFormatId');
        }
        if(searchParams.get('researchDocTypeId')) {
            newResearchDocTypeId = searchParams.get('researchDocTypeId');
        }
        if(searchParams.get('researchAgencyId')) {
            newResearchAgencyId = searchParams.get('researchAgencyId');
        }
        if(searchParams.get('capitalTypeId')) {
            newCapitalTypeId = searchParams.get('capitalTypeId');
        }
        if(searchParams.get('capitalSourceId')) {
            newCapitalSourceId = searchParams.get('capitalSourceId');
        }
        if(searchParams.get('fiscalYearId')) {
            newFiscalYearId = searchParams.get('fiscalYearId');
        }

        const response = await fetch(Config.apiUrl +'/research/list', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                keyword: refKeyword.current.value,
                researchTypeId: newResearchTypeId,
                researchFormatId: newResearchFormatId,
                researchDocTypeId: newResearchDocTypeId,
                researchAgencyId: newResearchAgencyId,
                capitalTypeId: newCapitalTypeId,
                capitalSourceId: newCapitalSourceId,
                fiscalYearId: newFiscalYearId,
                itemPerpage: itemPerpage,
                startItem: activePage > 1 ? (activePage * itemPerpage)-itemPerpage : 0,
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getResearchFromOther() {
        const response = await fetch(Config.apiUrl +'/researchFromOther/list', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getResearchType() {
        const response = await fetch(Config.apiUrl +'/researchType/list', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getResearchFormat() {
        const response = await fetch(Config.apiUrl +'/researchFormat/list', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getResearchDoctype() {
        const response = await fetch(Config.apiUrl +'/researchDoctype/list', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getResearchAgency() {
        const response = await fetch(Config.apiUrl +'/researchAgency/list', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getCapitalType() {
        const response = await fetch(Config.apiUrl +'/capitalType/list', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getCapitalSource() {
        const response = await fetch(Config.apiUrl +'/capitalSource/list', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getFiscalYear() {
        const response = await fetch(Config.apiUrl +'/fiscalYear/list', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    const onExportExcel = async () => {

        const listing = await getListing(1, 999999999);

        if(listing) {
            let array = [];
            for(let rs of listing.rows) {
                let json = {
                    title: rs.title,
                    author: rs.prefix + ' ' + rs.firstname + ' ' + rs.lastname,
                    researchAgency: rs.researchAgency?.title,
                    researchType: rs.researchType?.title,
                    researchFormat: rs.researchFormat?.title,
                    researchDoctype: rs.researchDoctype?.title,
                    capitalType: rs.capitalType?.title,
                    capitalSource: rs.capitalSource?.title,
                    fiscalYear: rs.fiscalYear?.title,
                    keywords: rs.keywords,
                    title_en: rs.title_en,
                    author_en: rs.prefix_en + ' ' + rs.firstname_en + ' ' + rs.lastname_en,
                    researchAgency_en: rs.researchAgency?.title_en,
                    researchType_en: rs.researchType?.title_en,
                    researchFormat_en: rs.researchFormat?.title_en,
                    researchDoctype_en: rs.researchDoctype?.title_en,
                    capitalType_en: rs.capitalType?.title_en,
                    capitalSource_en: rs.capitalSource?.title_en,
                    fiscalYear_en: rs.fiscalYear?.title_en,
                    keywords_en: rs.keywords_en,
                };
                array.push(json);
            }
            let finalHeaders = [['ชื่องานวิจัย', 'ผู้แต่ง', 'หน่วยงาน', 'ประเภทงานวิจัย', 'รูปแบบงานวิจัย', 'ประเภทเอกสาร', 'ประเภททุน', 'แหล่งทุน', 'ปีงบประมาณ', 'คำสำคัญ', 'ชื่องานวิจัย (EN)', 'ผู้แต่ง (EN)', 'หน่วยงาน (EN)', 'ประเภทงานวิจัย (EN)', 'รูปแบบงานวิจัย (EN)', 'ประเภทเอกสาร (EN)', 'ประเภททุน (EN)', 'แหล่งทุน (EN)', 'ปีงบประมาณ (EN)', 'คำสำคัญ (EN)']];
            const workbook = XLSX.utils.book_new();
            const worksheet= XLSX.utils.json_to_sheet(array, { origin: 'A2', skipHeader: true });
            XLSX.utils.sheet_add_aoa(worksheet, finalHeaders);

            XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
            const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
            const blob = new Blob([excelBuffer], {type: 'application/octet-stream'});
            saveAs(blob, `export_ncsa_research.xlsx`);
        }
        else {
            //toast.error("ไม่พบข้อมูลสมาชิก");
        }
    };

    return (
        <>
            <div className="section section-banner small">
                {
                    data?.image ? <img src={Config.fileUpload + 'research_banner/' + data?.image} alt="" /> : ''
                }
                <div className="container">
                    <h1 className="h2 textrow">
                        <span data-aos="fade-up">{prop.lang === 'en' ? 'Research':'ข้อมูลงานวิจัย'}</span>
                    </h1>

                    <div className="form-group search mt-sm-4 mt-2" data-aos="fade-in">
                        <input type="text" className="form-control" placeholder={prop.lang === 'en' ? 'Find Research':'ค้นหาข้อมูลงานวิจัย'} ref={refKeyword} />
                        <button className="btn btn-search" type="button" onClick={onSearch}>{prop.lang === 'en' ? 'Search':'ค้นหา'}</button>
                    </div>
                </div>
            </div>

            <div className="section">
                <div className="container has-sidebar" data-aos="fade-in">
                    <div className="sidebar">
                        <h3 className="fs-20 mb-lg-4 mb-2">{prop.lang === 'en' ? 'Filters':'ตัวกรอง'}</h3>
                        <div className="row g-lg-4 g-3">
                            {
                                researchType !== null && researchType.count > 0 ?
                                    <div className="col-lg-12 col-md-4">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'Research Type':'ประเภทงานวิจัย'}</h6>
                                            <select className="form-select" onChange={onChangeResearchType} defaultValue={researchTypeId}>
                                                <option value="">{prop.lang === 'en' ? 'Select':'กรุณาเลือก'}</option>
                                                {
                                                    researchType.rows.map((row, index) => {
                                                        return (
                                                            <option key={index} value={row.id}>{prop.lang === 'en' ? row.title_en:row.title}</option>
                                                        )
                                                    })
                                                }
                                            </select>
                                        </div>
                                    </div> : ''
                            }

                            {
                                researchFormat !== null && researchFormat.count > 0 ?
                                    <div className="col-lg-12 col-md-4">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'Research Format':'รูปแบบงานวิจัย'}</h6>
                                            <select className="form-select" onChange={onChangeResearchFormat} defaultValue={researchFormatId}>
                                                <option value="">{prop.lang === 'en' ? 'Select':'กรุณาเลือก'}</option>
                                                {
                                                    researchFormat.rows.map((row, index) => {
                                                        return (
                                                            <option key={index} value={row.id}>{prop.lang === 'en' ? row.title_en:row.title}</option>
                                                        )
                                                    })
                                                }
                                            </select>
                                        </div>
                                    </div> : ''
                            }

                            {
                                researchDoctype !== null && researchDoctype.count > 0 ?
                                    <div className="col-lg-12 col-md-4">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'Research Document':'ประเภทเอกสาร'}</h6>
                                            <select className="form-select" onChange={onChangeResearchDoctype} defaultValue={researchDoctypeId}>
                                                <option value="">{prop.lang === 'en' ? 'Select':'กรุณาเลือก'}</option>
                                                {
                                                    researchDoctype.rows.map((row, index) => {
                                                        return (
                                                            <option key={index} value={row.id}>{prop.lang === 'en' ? row.title_en:row.title}</option>
                                                        )
                                                    })
                                                }
                                            </select>
                                        </div>
                                    </div> : ''
                            }

                            {
                                researchAgency !== null && researchAgency.count > 0 ?
                                    <div className="col-lg-12 col-md-4">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'Research Agency':'หน่วยงาน'}</h6>
                                            <select className="form-select" onChange={onChangeResearchAgency} defaultValue={researchAgencyId}>
                                                <option value="">{prop.lang === 'en' ? 'Select':'กรุณาเลือก'}</option>
                                                {
                                                    researchAgency.rows.map((row, index) => {
                                                        return (
                                                            <option key={index} value={row.id}>{prop.lang === 'en' ? row.title_en:row.title}</option>
                                                        )
                                                    })
                                                }
                                            </select>
                                        </div>
                                    </div> : ''
                            }

                            {
                                capitalType !== null && capitalType.count > 0 ?
                                    <div className="col-lg-12 col-md-4">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'Capital Type':'ประเภททุน'}</h6>
                                            <select className="form-select" onChange={onChangeCapitalType} defaultValue={capitalTypeId}>
                                                <option value="">{prop.lang === 'en' ? 'Select':'กรุณาเลือก'}</option>
                                                {
                                                    capitalType.rows.map((row, index) => {
                                                        return (
                                                            <option key={index} value={row.id}>{prop.lang === 'en' ? row.title_en:row.title}</option>
                                                        )
                                                    })
                                                }
                                            </select>
                                        </div>
                                    </div> : ''
                            }

                            {
                                capitalSource !== null && capitalSource.count > 0 ?
                                    <div className="col-lg-12 col-md-4">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'Capital Source':'แหล่งทุน'}</h6>
                                            <select className="form-select" onChange={onChangeCapitalSource} defaultValue={capitalSourceId}>
                                                <option value="">{prop.lang === 'en' ? 'Select':'กรุณาเลือก'}</option>
                                                {
                                                    capitalSource.rows.map((row, index) => {
                                                        return (
                                                            <option key={index} value={row.id}>{prop.lang === 'en' ? row.title_en:row.title}</option>
                                                        )
                                                    })
                                                }
                                            </select>
                                        </div>
                                    </div> : ''
                            }

                            {
                                fiscalYear !== null && fiscalYear.count > 0 ?
                                    <div className="col-lg-12 col-md-4">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'FiscalYear':'ปีงบประมาณ'}</h6>
                                            <select className="form-select" onChange={onChangeFiscalYear} defaultValue={fiscalYearId}>
                                                <option value="">{prop.lang === 'en' ? 'Select':'กรุณาเลือก'}</option>
                                                {
                                                    fiscalYear.rows.map((row, index) => {
                                                        return (
                                                            <option key={index} value={row.id}>{prop.lang === 'en' ? row.title_en:row.title}</option>
                                                        )
                                                    })
                                                }
                                            </select>
                                        </div>
                                    </div> : ''
                            }

                            <div className="col-12">
                                <button className="btn w-100 my-2" type="button" onClick={onSearch}>{prop.lang === 'en' ? 'Search':'แสดงผลการค้นหา'}</button>
                            </div>
                        </div>
                    </div>
                    <div className="content">
                        <div className="hgroup" data-aos="fade-in">
                            <div className="d-flex">
                                <div>
                                    <h2>{prop.lang === 'en' ? 'Search results':'ผลการค้นหา'}</h2>
                                    <p className="m-0 d-none">{prop.lang === 'en' ? 'Results':'รายการที่ 1 ถึง 10 จาก ' + countAllItem + ' รายการ'}</p>
                                </div>
                                <div className="show-list">
                                    <button className="btn btn-xs btn-green w-130 float-end" onClick={onExportExcel}>
                                        {prop.lang === 'en' ? 'Export Excel':'Export Excel'}
                                    </button>
                                </div>
                            </div>
                            <hr />
                        </div>

                        {
                            listing !== null && listing.count > 0 ?
                                <>
                                    <div className="row g-3">
                                        {
                                            listing.rows.map((row, index) => {
                                                return (
                                                    <div key={index} className="col-12">
                                                        <div class="card-infos" data-aos="fade-in">
                                                            <h3 className="fs-20"><NavLink to={(prop.lang === 'en' ? '/en':'') + '/research/detail/' + row.slug} className="link-title">{prop.lang === 'en' ? row.title_en:row.title}</NavLink></h3>
                                                            <ul class="infos-list">
                                                                <li>
                                                                    <h6>{prop.lang === 'en' ? 'Author':'ผู้แต่ง'} :</h6>
                                                                    <p>{prop.lang === 'en' ? row.prefix_en + ' ' + row.firstname_en + ' ' + row.lastname_en : row.prefix + ' ' + row.firstname + ' ' + row.lastname}</p>
                                                                </li>

                                                                {
                                                                    row.researchCoauthor !== null && row.researchCoauthor.length > 0 ?
                                                                        <li>
                                                                            <h6>{prop.lang === 'en' ? 'Author':'ผู้แต่งร่วม'} :</h6>
                                                                            <p>
                                                                                {prop.lang === 'en' ? row.researchCoauthor.map(function (rs) {
                                                                                    return rs.prefix_en + ' '  +rs.firstname_en + ' '  +rs.lastname_en;
                                                                                }).join(', ') : row.researchCoauthor.map(function (rs) {
                                                                                    return rs.prefix + ' '  +rs.firstname + ' '  +rs.lastname;
                                                                                }).join(', ')
                                                                                }
                                                                            </p>
                                                                        </li> : ''
                                                                }

                                                                {
                                                                    row.researchAgency ?
                                                                        <li>
                                                                            <h6>{prop.lang === 'en' ? 'Agency':'หน่วยงาน'} :</h6>
                                                                            <p>{prop.lang === 'en' ? row.researchAgency.title_en:row.researchAgency.title}</p>
                                                                        </li> : ''
                                                                }

                                                                {
                                                                    row.researchType ?
                                                                        <li>
                                                                            <h6>{prop.lang === 'en' ? 'Research Type':'ประเภทงานวิจัย'} :</h6>
                                                                            <p>{prop.lang === 'en' ? row.researchType.title_en:row.researchType.title}</p>
                                                                        </li> : ''
                                                                }

                                                                {
                                                                    row.researchFormat ?
                                                                        <li>
                                                                            <h6>{prop.lang === 'en' ? 'Research Format':'รูปแบบงานวิจัย'} :</h6>
                                                                            <p>{prop.lang === 'en' ? row.researchFormat.title_en:row.researchFormat.title}</p>
                                                                        </li> : ''
                                                                }

                                                                {
                                                                    row.researchDoctype ?
                                                                        <li>
                                                                            <h6>{prop.lang === 'en' ? 'Research Document':'ประเภทเอกสาร'} :</h6>
                                                                            <p>{prop.lang === 'en' ? row.researchDoctype.title_en:row.researchDoctype.title}</p>
                                                                        </li> : ''
                                                                }

                                                                {
                                                                    row.capitalType ?
                                                                        <li>
                                                                            <h6>{prop.lang === 'en' ? 'Capital Type':'ประเภททุน'} :</h6>
                                                                            <p>{prop.lang === 'en' ? row.capitalType.title_en:row.capitalType.title}</p>
                                                                        </li> : ''
                                                                }

                                                                {
                                                                    row.capitalSource ?
                                                                        <li>
                                                                            <h6>{prop.lang === 'en' ? 'Capital Source':'แหล่งทุน'} :</h6>
                                                                            <p>{prop.lang === 'en' ? row.capitalSource.title_en:row.capitalSource.title}</p>
                                                                        </li> : ''
                                                                }

                                                                {
                                                                    row.fiscalYear ?
                                                                        <li>
                                                                            <h6>{prop.lang === 'en' ? 'Fiscal Year':'ปีงบประมาณ'} :</h6>
                                                                            <p>{prop.lang === 'en' ? row.fiscalYear.title_en:row.fiscalYear.title}</p>
                                                                        </li> : ''
                                                                }

                                                                {
                                                                    row.keywords ?
                                                                        <li>
                                                                            <h6>{prop.lang === 'en' ? 'Keywords':'คำสำคัญ'} :</h6>
                                                                            <p>{prop.lang === 'en' ? row.keywords_en:row.keywords}</p>
                                                                        </li> : ''
                                                                }
                                                            </ul>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>

                                    <div className={totalPage > 1 ? '':'d-none'}>
                                        <Pagination
                                            itemClassPrev="arrow prev"
                                            itemClassNext="arrow next"
                                            activeClass="active"
                                            itemClass=""
                                            linkClass=""
                                            innerClass="pagination justify-content-sm-end py-4 my-3"
                                            activePage={activePage}
                                            itemsCountPerPage={itemPerpage}
                                            totalItemsCount={countAllItem}
                                            pageRangeDisplayed={5}
                                            onChange={(pageNum) => onPageChange(pageNum)}
                                        />
                                    </div>
                                </> : <p>{prop.lang === 'en' ? 'Not found':'ไม่พบข้อมูล'}</p>
                        }

                        {
                            researchFromOther !== null && researchFromOther.count > 0 ?
                                <>
                                    <div className="card-infos has-shadow mt-sm-4" data-aos="fade-in">
                                        <h2>{prop.lang === 'en' ? 'Research From Other':'ค้นหางานวิจัยจากฐานข้อมูลอื่น'}</h2>
                                        <ul className="infos-list links has-line">
                                            {
                                                researchFromOther.rows.map((row, index) => {
                                                    return (
                                                        <li key={index}>
                                                            <img className="svg-js icons w-20" src={IconWeb} alt="" />
                                                            <div>
                                                                <p><strong>{prop.lang === 'en' ? row.title_en:row.title}</strong></p>
                                                                <p className="fs-14 text-info"><NavLink to={prop.lang === 'en' ? row.link_en:row.link} className="link-primary" target="_blank">{prop.lang === 'en' ? row.link_en:row.link}</NavLink></p>
                                                            </div>
                                                        </li>
                                                    )
                                                })
                                            }
                                        </ul>
                                    </div>
                                </> : ''
                        }
                    </div>
                </div>
            </div>
        </>
    );
} 